var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tripCode && _vm.tripCode != -1)?[_c('view_trip')]:[_c('editable_trip')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }